var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"pt-3 pb-5 vh-adjust"},[_c('h3',{staticClass:"mb-45"},[_vm._v(" Data Center 목차 편집하기 ")]),_c('DataCenterToC',{staticStyle:{"width":"70%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }